module.exports = __webpack_public_path__ + "static/media/splash.e5514498.jpg";